import React from 'react'
import {useForm} from 'utils/hooks/form'
import EditableTextChromeExtension from 'components/EditableTextChromeExtension'
import Button from 'components/Button'
import ChromeContentService from 'services/Chrome/ChromeContentService'
import services from 'services'
import {useFunction} from 'utils/hooks/function'
import {usePublished} from 'utils/published'
import {ReactComponent as CrossChromeExtension} from './assets/cross-itx-chrome-extension.svg'

type ProblemInputProps = {
  x: number
  y: number
  remove: () => void
  service: ChromeContentService
}

export default function ProblemInput(props: ProblemInputProps) {
  const service = services.getChromeContentService()
  const project = usePublished(service.project)!
  const submitProblem = useFunction(service.sendProblem)

  const form = useForm({
    title: '',
    description: '',
    projectId: project.id,
  })

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '16px',
        position: 'absolute',
        width: '560px',
        height: '300px',
        backgroundColor: 'white',
        borderWidth: '1px',
        borderRadius: '10px',
        zIndex: 999999999999999,
        left: props.x,
        top: props.y,
        boxSizing: 'border-box',
        boxShadow: '0px 0px 1px rgba(38, 40, 46, 0.05), 0px 2px 4px rgba(38, 40, 46, 0.1)',
      }}
    >
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
          <CrossChromeExtension
            onClick={() => {
              props.remove()
            }}
            style={{cursor: 'pointer'}}
          />
        </div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <EditableTextChromeExtension
            editable
            placeholder="Problem title"
            value={form.state.title}
            onChange={(t) => form.update('title', t)}
            className="font-sans font-semibold text-primary-darkest placeholder-itx-gray-base mt-2 w-full"
            style={{fontSize: '20px', border: 'none'}}
            updateEditMode={() => {}}
          />
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', height: '128px', width: '100%'}}>
            <EditableTextChromeExtension
              editable
              placeholder="Write the description"
              value={form.state.description}
              onChange={(t) => form.update('description', t)}
              className="font-sans font-medium text-primary-darkest placeholder-itx-gray-base outline-none resize-none mt-2 w-full"
              style={{fontSize: '16px', border: 'none'}}
              isParagraph
              updateEditMode={() => {}}
            />
          </div>
        </div>
      </div>
      <div style={{display: 'flex', flexDirection: 'row', alignSelf: 'flex-end'}}>
        <Button
          loading={submitProblem.isRunning}
          disabled={submitProblem.isRunning}
          className="itx-button mt-12 rounded-lg border px-4 text-white font-regular bg-itx-primary-4 hover:bg-itx-primary-3 pt-0 items-baseline border-none h-8 flex-shrink-0 hover:shadow-md transition duration-200"
          style={{fontSize: '16px'}}
          content="Post"
          onClick={() => {
            submitProblem({
              form: form.state,
              position: {x: props.x, y: props.y},
            })
          }}
        />
      </div>
    </div>
  )
}
